import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	loading: false,
	error: null,
	questions: null,
	pickedQuestions: null,
	currentQuestion: null,
	numberOfQuestions: 10,
	activeQuestion: null,
	quizStage: "init",
	answers: 0,
	quizSession: null,
	sessionTotalTime: 0
}

const quizInit = (state, action) => {
	return updateObject ( state, { 
		quizSession: action.quizSession
	});
}

const quizSetQuestions = (state, action) => {
	
	let n = state.numberOfQuestions;
	//console.log('number of q: ' + n)
	let result = Array(n);
	let arr = action.q;
	let len = arr.length;
		
	let taken = new Array(len);

		//console.log('arr: '+arr);
		//console.log('len: '+len);

	if (n > len) {
		throw new RangeError("not enough source questions for 10 random ones");
	}
	// picking random elements from questions array
	while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
	}
	
	return updateObject ( state, { questions: action.q, pickedQuestions: result, activeQuestion: 1 } );
}



const quizStartLoading = (state,action) => {
	return updateObject ( state, { loading: true} );
}

const quizStopLoading = (state,action) => {
	return updateObject ( state, { loading: false} );
}

const quizChangeStage = ( state, action ) => {
	return updateObject( state, { quizStage: action.stage} );
}


const answer = (state, action) => {
	//console.warn('ANSWER REDUCER',action.answer);
	let newAnswer = state.answers;

	// check if we have reached final answer
	let newQuestion = state.activeQuestion+1;
	if (action.answer) {
		newAnswer++;
	}
	
	if (newQuestion <= state.numberOfQuestions) {
		return updateObject ( state, {
			answers: newAnswer,
			activeQuestion: newQuestion
		});
	} else {
		return updateObject ( state, {
			answers: newAnswer
			// OVO PROVERITI!!!!!!******
			//quizStage: 'ended'
		});
	}

	//return updateObject ( state, { answers: action.updatedAnswers, activeQuestion: action.updatedActiveQuestion })
}

const endQuiz = (state, action ) => {
	//console.warn('total time', action.final);
	return updateObject ( state , {
		sessionTotalTime: action.final
	})
}

const quizReset = (state, action) => {
	return updateObject ( state, {
		...initialState
	})
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
		case actionTypes.QUIZ_INIT: return quizInit(state, action);
        case actionTypes.QUIZ_CHANGESTAGE: return quizChangeStage(state, action);
		case actionTypes.QUIZ_SETQUESTIONS: return quizSetQuestions(state, action);
        case actionTypes.QUIZ_ANSWER: return answer(state, action);
        case actionTypes.QUIZ_ENDQUIZ: return endQuiz(state, action);
		case actionTypes.QUIZ_STARTLOADING: return quizStartLoading(state, action);
		case actionTypes.QUIZ_STOPLOADING: return quizStopLoading(state, action);
		case actionTypes.QUIZ_RESET: return quizReset(state, action);
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/quiz.js